var Layer  = require('./Layer'),
    Events = require("Events"),
    Utils  = require('Utils'),
    ol     = require('openlayers');

var $ = require('jquery');

var UTFGrid = Layer.extend({
    includes: Events,

    options: {
        subdomains: false,

        minZoom : 0,
        maxZoom : 30,
        tileSize: 256,

        resolution: 4,

        events: true,

        url: ''
    },

    initialize: function (options) {
        var that = this;

        options || (options = {});

        UTFGrid.__super__.initialize.call(that, options);

        //The thing the mouse is currently on
        that._mouseOn = null;

        // Timeout to update grid
        that._updateTimeout = null;

        // Last MouseMove EventArgs
        that._lastUpdateEventArgs = null;

        that._cache    = {};
        that._requests = {};

        that._tilesOn = true;

        that._clickDiaposon = false;
        that._clickTimer = false;

        that.inverseY = false;

        that._click = that._click.bind(this);
        that._move = that._move.bind(this);

        if (that.options.subdomains) {
            that.options.subdomains = that.options.subdomains.split('-');
            that.options.subdomains = letterRange(that.options.subdomains[0], that.options.subdomains[1]);
        }

        that._olLayer = new ol.layer.Tile({});

        // Избавляемся от rnd в запросах на тайлы
        // that.set('rnd', Math.floor((Math.random() * 999999) + 1));

        that.setUrl(that._createUrl());

        that.on('propertychange propertyunset', function () {
            that.setUrl(that._createUrl());
        });
    },


    onAdd: function (view) {
        var that = this;

        that._view = view;

        that._map       = that._view.getMap();
        that._container = that._map.getTargetElement();
        that._tilegrid  = ol.tilegrid.getForProjection(that._map.getView().getProjection());
        that.enable();
    },

    toggleTiles: function (toggle) {
        this._tilesOn = !!toggle;
    },

    set: function (attr, value, silent) {
        var that = this,
            attrs,
            i;

        if (typeof attr === "string") {
            attrs       = {};
            attrs[attr] = value;
        } else {
            attrs  = attr;
            silent = value;
        }

        for (i in attrs) {
            that._attributes[i] = attrs[i];
            if (!silent) {
                that.fire('propertychange', {
                    key  : i,
                    value: attrs[i]
                })
            }
        }
    },

    unset: function (key, value, silent) {
        var that = this;
        if (key in that._attributes) {
            delete that._attributes[key]
        }

        if (!silent) {
            that.fire('propertyunset', {
                key: key
            })
        }
    },

    disable: function () {
        var that = this;
        that.enabled = false;
        that._map.un('click', that._click);
        that._map.un('pointermove', that._move);
    },

    enable: function () {
        var that = this;
        that.enabled = true;
        that._map.on('click', that._click);
        that._map.on('pointermove', that._move);
    },

    setUrl: function (url) {
        var that = this;
        that.cancelLoading();
        that.clearCache();
        that.inverseY = Boolean(~url.indexOf('{-y}'));
        that._url     = url.replace('{-y}', '{y}');
    },

    _createUrl: function () {
        var that = this,
            re   = /\{ *([\w_]+) *\}/g,
            url  = that.options.url,
            i,
            param;

        var tmp_params = [];

        // Нужно сначала через template прогнать все переменные, которые у нас есть
        // Оставшиеся добавляем get параметрами
        var vars = that.options.url.match(re);
        for (var i in vars) {
            vars[i] = vars[i].replace('{', '').replace('}', '');

            tmp_params.push(vars[i]);
        }


        for (i in that._attributes) {
            if (~tmp_params.indexOf(i)) {
                continue;
            }
            param = Object.prototype.toString.call(that.get(i)) === '[object Array]'
                ? that.get(i).join(",")
                : that.get(i) || "";

            url += '&' + i + "=" + param;
        }

        return url;
    },

    _move: function (e, instance) {
        var that = this;
        if (e === null) return;
        clearTimeout(that._updateTimeout);
        if (!that.options.events) return;

        function delayedUpdate() {
            that._updateByPoint(e, false);
            that._lastUpdateEventArgs = e;
        }

        if (instance) {
            delayedUpdate();
        } else {
            that._updateTimeout = setTimeout(delayedUpdate, 100);
        }

        var on = that._objectForEvent(e);

        if (on.data !== that._mouseOn) {
            if (that._mouseOn) {
                that.fire('mouseout',
                    {
                        coordinate: e.coordinate,
                        data      : that._mouseOn
                    });
            }
            if (on.data) {
                that.fire('mouseover', on);
            }

            that._mouseOn = on.data;
        } else if (on.data) {
            that.fire('mousemove', on);

        }
    },

    //Load up required json grid files for point
    _updateByPoint: function (e, hard) {
        var that = this;
        hard     = hard || false;

        if (!that._map || e === null) return void(0);
        var zoom     = that._map.getView().getZoom(),
            tileSize = that.options.tileSize,
            coord    = ol.proj.transform(e.coordinate, 'EPSG:3857', 'EPSG:4326'),
            pixel    = project([coord[0], coord[1]], zoom);

        if (zoom > that.options.maxZoom || zoom < that.options.minZoom) return void(0);

        var TileX = Math.floor(pixel[0] / tileSize);
        var TileY = Math.floor(pixel[1] / tileSize);
        var max   = (256 * Math.pow(2, zoom)) / tileSize;

        var xw = (TileX + max) % max;
        var yw = (TileY + max) % max;

        if (that.inverseY) {
            yw = (Math.pow(2, zoom) - yw - 1)
        }

        var key = zoom + '_' + xw + '_' + yw;

        if ((Math.floor(zoom) !== zoom) || (Math.floor(xw) !== xw) || (Math.floor(yw) !== yw)) {
            return;
        }

        if (!that._cache.hasOwnProperty(key) || hard) {
            that._cache[key] = null;
            that._loadTile(zoom, xw, yw);
        }
    },

    _loadTile: function (zoom, x, y) {
        var that = this;

        var params = $.extend(true, {
            x: x,
            y: y,
            z: zoom
        }, that._attributes);

        var url = Utils.template(that._url, params);

        var key = zoom + '_' + x + '_' + y;

        if (!that._tilesOn) {
            return;
        }
        that.fire('tileloadstart');
        that._requests[key] = $.ajax({
                dataType: "json",
                cache   : true,
                url     : url
            })
            .done(function (data) {
                delete that._requests[key];
                
                // проверяем данные на пустоту
                if (JSON.stringify(data) != "{}") {
                    that._cache[key] = data;
                    that._move(that._lastUpdateEventArgs);
                    that.fire('tileloadend');
                } else {
                    that.fire('tileloaderror');
                }
            })
            .fail(function () {
                delete that._requests[key];
                that.fire('tileloaderror');
            });

    },

    _objectForEvent: function (e) {

        var that       = this,
            map        = that._map,
            zoom       = map.getView().getZoom(),
            coord      = ol.proj.transform(e.coordinate, 'EPSG:3857', 'EPSG:4326'),
            point      = project([coord[0], coord[1]], zoom),
            tileSize   = that.options.tileSize,
            resolution = that.options.resolution,
            x          = Math.floor(point[0] / tileSize),
            y          = Math.floor(point[1] / tileSize),
            gridX      = Math.floor((point[0] - (x * tileSize)) / resolution),
            gridY      = Math.floor((point[1] - (y * tileSize)) / resolution),
            max        = (256 * Math.pow(2, zoom)) / tileSize;

        x = (x + max) % max;
        y = (y + max) % max;

        if (that.inverseY) {
            y = (Math.pow(2, zoom) - y - 1)
        }

        var data = that._cache[zoom + '_' + x + '_' + y];

        if (!data) {
            return {
                coordinate: e.coordinate,
                data      : null
            };
        }

        var idx    = that._utfDecode(data.grid[gridY].charCodeAt(gridX)),
            key    = data.keys[idx],
            result = data.data[key];

        if (!data.data.hasOwnProperty(key)) {
            result = null;
        }

        return {
            coordinate: e.coordinate,
            data      : result,
            zoom      : zoom
        };
    },

    _utfDecode: function (c) {
        if (c >= 93) {
            c--;
        }
        if (c >= 35) {
            c--;
        }
        return c - 32;
    },

    _click: function (e) {
        var req;
        var key;
        var that = this;
        var gridLoader = $.Deferred();
        var objForEvent = {};

        if (that._view._utfIgnoreClick) return;
        if (!that.options.events) return;
        if(that._clickDiaposon){
            clearTimeout(that._clickTimer);
            that.cancelLoading();
            that._clickDiaposon = false;
        }else {
            that._clickDiaposon = true;
            that._clickTimer = setTimeout(function(){
                that._clickDiaposon = false;
                try {
                    document.createEvent("TouchEvent");
                    that._move(e, true);
                }
                catch (e) {}
                // Обратная совместимость со старыми клиентами
                objForEvent = that._objectForEvent(e);
                objForEvent.gridLoader  = gridLoader;

                that.fire('click', objForEvent);

                req = [];
                for (key in that._requests) {
                    req.push(that._requests[key]);
                }

                $.when.apply($, req).always(function () {
                    that._clickDiaposon = false;
                    if (that._objectForEvent(e).data != null) {
                        gridLoader.resolve(that._objectForEvent(e));
                    } else {
                        gridLoader.reject(e);
                    }
                })
            },200);
        }
    },

    cancelLoading: function () {
        var i;
        for (i in this._requests) {
            this._requests[i].abort();
        }
    },

    clearCache: function () {
        this._cache = {};

        // Избавляемся от rnd в запросах на тайлы
        // this.set('rnd', Math.floor((Math.random() * 999999) + 1), true);
    }
});


var Transformation = function (a, b, c, d) {
    this._a = a;
    this._b = b;
    this._c = c;
    this._d = d;
};

Transformation.prototype = {
    transform: function (point, scale) { // (Point, Number) -> Point
        return this._transform(point.clone(), scale);
    },

    // destructive transform (faster)
    _transform: function (point, scale) {
        scale    = scale || 1;
        point[0] = scale * (this._a * point[0] + this._b);
        point[1] = scale * (this._c * point[1] + this._d);
        return point;
    },

    untransform: function (point, scale) {
        scale = scale || 1;
        return [
            (point[0] / scale - this._b) / this._a,
            (point[1] / scale - this._d) / this._c
        ];
    }
};

var projection = {
    MAX_LATITUDE: 85.0511287798,

    project: function (latlng) { // (LatLng) -> Point
        var d   = Math.PI / 180,
            max = this.MAX_LATITUDE,
            lat = Math.max(Math.min(max, latlng[1]), -max),
            x   = latlng[0] * d,
            y   = lat * d;

        y = Math.log(Math.tan((Math.PI / 4) + (y / 2)));

        return [x, y];
    },

    unproject: function (point) { // (Point, Boolean) -> LatLng
        var d   = 180 / Math.PI,
            lng = point[0] * d,
            lat = (2 * Math.atan(Math.exp(point[1])) - (Math.PI / 2)) * d;

        return [lat, lng];
    }
};

var CRS = {
    latLngToPoint: function (latlng, zoom) { // (LatLng, Number) -> Point
        var projectedPoint = this.projection.project(latlng),
            scale          = this.scale(zoom);

        return this.transformation._transform(projectedPoint, scale);
    },

    pointToLatLng: function (point, zoom) { // (Point, Number[, Boolean]) -> LatLng
        var scale              = this.scale(zoom),
            untransformedPoint = this.transformation.untransform(point, scale);

        return this.projection.unproject(untransformedPoint);
    },

    scale: function (zoom) {
        return 256 * Math.pow(2, zoom);
    },

    getSize: function (zoom) {
        var s = this.scale(zoom);
        return [s, s];
    },

    code: 'EPSG:3857',

    projection: projection,

    transformation: new Transformation(0.5 / Math.PI, 0.5, -0.5 / Math.PI, 0.5),

    project: function (latlng) { // (LatLng) -> Point
        var projectedPoint = this.projection.project(latlng),
            earthRadius    = 6378137;
        projectedPoint[0] *= earthRadius;
        projectedPoint[1] *= earthRadius;

        return projectedPoint;
    }
};

var project = function (latlng, zoom) { // (LatLng[, Number]) -> Point
    return CRS.latLngToPoint(latlng, zoom);
};

var letterRange = function (start, stop) {
    var result = [];
    for (var idx = start.charCodeAt(0), end = stop.charCodeAt(0); idx <= end; ++idx) {
        result.push(String.fromCharCode(idx));
    }
    return result;
};

module.exports = UTFGrid;


//////////////////
// WEBPACK FOOTER
// ./src/View/UTFGrid.js
// module id = 244
// module chunks = 0